// plugins/install-prompt.client.ts
export default defineNuxtPlugin(() => {
  window.addEventListener('beforeinstallprompt', (e: Event) => {
    const ev = e as any; // minimal typing
    // предотвратить авто-показ и сохранить событие
    try { ev.preventDefault(); } catch(e) { /* ignore */ }

    // сохраняем глобально для отладки/ручного вызова
    (window as any)._deferredPrompt = ev;

    // создаём удобный helper для консоли
    (window as any).showPwaInstall = async () => {
      const dp = (window as any)._deferredPrompt;
      if (!dp) {
        console.warn('No deferredPrompt saved');
        return null;
      }
      try {
        await dp.prompt();
        const choice = await dp.userChoice;
        console.log('PWA install choice:', choice);
        // очистим
        (window as any)._deferredPrompt = null;
        return choice;
      } catch (err) {
        console.error('showPwaInstall error', err);
        return null;
      }
    };

    // оповестим приложение через событие, чтобы компоненты могли показать кнопку
    window.dispatchEvent(new CustomEvent('pwa-beforeinstallprompt'));

    console.log('[PWA plugin] beforeinstallprompt captured and saved to window._deferredPrompt');
  });
});
